import { Chip, Stack, Theme, Typography } from "@mui/material";
import { SxProps } from "@mui/system";
import { MouseEventHandler, type JSX } from "react";

export type SquareChipProps = {
    header?: string;
    label?: string | JSX.Element | undefined | null;
    checked: boolean;
    disabled?: boolean;
    onClick?: MouseEventHandler<HTMLDivElement>;
    size?: 'small' | 'medium';
    colorOverride?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    checkedColorOverride?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'black';
    sx?: SxProps<Theme>
};

export default function SquareChip({
    header,
    label,
    checked,
    disabled,
    size,
    onClick,
    colorOverride,
    checkedColorOverride,
    sx
}: SquareChipProps): JSX.Element {
    return (
        <Stack direction='column'>
            {header && 
                <Typography
                    variant='subtitle2'
                    sx={{
                        fontWeight: 600,
                        padding:0,
                        fontSize: size === 'small' ? '.6rem' : '.7rem',
                        alignSelf: 'center'
                    }}>
                    {header}
                </Typography>
            }
            <Chip
                label={
                    <Typography
                        variant='subtitle2'
                        color={checked && checkedColorOverride === 'black' ? '#ffffff' : undefined}
                        sx={{
                            fontWeight: 600,
                            fontSize: size === 'small' ? '.8rem' : undefined,
                            padding:0
                        }}>
                        {label}
                    </Typography>}
                color={checked ? checkedColorOverride === 'black' ? 'default' : checkedColorOverride ?? "secondary" : colorOverride ?? "default"}
                onClick={disabled ? undefined : onClick}
                size={size ?? 'medium'}
                sx={{
                    margin: .5,
                    marginTop: header ? '-2px' : undefined,
                    maxWidth: size === 'small' ? '26px' : '32px',
                    borderRadius: "2px",
                    width: theme => theme.spacing(7),
                    ':hover': {
                        cursor: 'pointer',
                        backgroundColor: checked && checkedColorOverride === 'black' ? '#000' : undefined,
                    },
                    opacity: disabled ? theme => theme.palette.action.disabledOpacity : 1,
                    "& span": {
                        padding: 0
                    },
                    background: checked && checkedColorOverride === 'black' ? '#000' : undefined,
                    ...sx
                }}
            />
        </Stack>
    );
}
